module.exports = __webpack_public_path__ + "static/img/35.a08b8f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/35.png
// module id = oLv7
// module chunks = 0